import deepmerge from "deepmerge";
import filter from "lodash/filter";

export function getNumberOfFiltersApplied(filters) {
  const isBlank = (value) => !value;
  const isPresent = (value) => !!value;

  return filter(filters, (value, _) => {
    if (isBlank(value)) {
      return false;
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === "object") {
      return isPresent(value.startsAt) || isPresent(value.endsAt);
    }
    return true;
  }).length;
}

export function mergeState(object1, object2) {
  return deepmerge(object1, object2, {
    arrayMerge: (_oldArray, newArray) => newArray,
  });
}
